import React, { useEffect, useState } from 'react';
import SettingsService from '../../../../../../services/api/settings.service';
import defaultLogo from '../../../../../../../assets/images/logo_login.png'
import StorageService from '../../../../../../services/session/storage.service';
import APIResponse from '../../../../../templates/components/APIResponse';
import DimLoader from '../../../../../templates/components/DimLoader'
const PracticeLocationLogo = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const [logo, setLogo] = useState()
    const [selectedFile, setSelectedFile] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }

    const getLogo = () => {
        let logoPath = StorageService.getLogo(props.locationId);
        if (logoPath) {
            setLogo(logoPath)
        }
        else {
            setLogo(defaultLogo)
        }
    }
    const submitLogo = (e) => {
        setIsLoader(true)
        SettingsService.putPracticeLocationLogo(selectedFile, props.locationId)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    useEffect(() => {
        getLogo()
    }, [])
    return (
        <div>
            {isLoader && <DimLoader />}
            <div className='row d-flex justify-content-around'>
                <div className='col-12'>
                    <div className='card m-3'>
                        <div className='bg-primary d-flex justify-content-center'>
                            <div style={{ backgroundImage: `url(${logo})` }} className="logo-upload" />
                        </div>
                        <hr className='p-0 m-0' />
                        <div className="card-body">
                            <input className="" type="file" id="formFile" 
                            onChange={e => {
                                e.preventDefault();
                                const file = e.target.files[0];
                                if (file) {
                                    setSelectedFile(file)
                                    const newLogoUrl = URL.createObjectURL(file);
                                    setLogo(newLogoUrl);
                                }
                            }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='mt-3 d-flex justify-content-between modal-button-bar'>
                <div className='col-auto'>
                    <button className="btn btn-primary" onClick={(e) => {
                        e.preventDefault();
                        submitLogo()
                    }}>Update</button>
                </div>
                <div className='col-auto'>
                    <button className="btn btn-secondary" onClick={(e) => { e.preventDefault(); if (props.onClose()) { props.onClose() } }}> Cancel </button>
                </div>
            </div>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true}/>
        </div>
    )
}

export default PracticeLocationLogo;